// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plot-block-container {
    width: 100%;
    height: 400px;
    border: var(--border);
    border-radius: var(--border-radius);
    margin: 5px 0px;
    letter-spacing: normal;
}

.plot-grid-container {
    border-radius: var(--border-radius);
}

.plot-grid-content-box {
    padding: 5px;
    height: calc(100% - 40px);
    overflow: auto;
    background: transparent;
}

/*TOOLTIP ZONE*/
.tooltip-container {
    margin: -10px; /*Negative margins give the user powers that some would consider... unnatural.*/
    padding: 5px;
    border-radius: 10px;
}

.tooltip-container .echarts-legend-description {
    max-width: 200px; 
    text-wrap: wrap;
}

.tooltip-container .tooltip-header {
    padding: 0px 5px;
    margin-bottom: 2px;
}

.tooltip-container .big-boy-marker {
    display: block;
    height: 12px;
    width: 100%;
    border-radius: 10px;
}

.tooltip-container .tooltip-body {
    padding: 0px 5px;
}

.tooltip-container p {
    margin: 0;
    padding: 0 5px;
}

.tooltip-container p:first-of-type {
    padding-left: 0;
}

.tooltip-container p:last-of-type {
    padding-right: 0;
}

.tooltip-container .tooltip-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tooltip-container .tooltip-row > * {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
    height: 100%;
}

.tooltip-container .tooltip-row .tooltip-row-identifier {
    display: flex;
    padding: 0;
    margin-right: 5px;
}

.tooltip-container .tooltip-value {
    font-weight: bold;
}

.tooltip-container .tooltip-single-value {
    font-weight: bold;
    font-size: larger;
}

.tooltip-container .tooltip-row:has(.tooltip-single-value) {
    justify-content: center;
}

.tooltip-container .tooltip-row:has(:only-child) {
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLGridPlotBlock/ECLGridPlotBlock.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mCAAmC;IACnC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,aAAa,EAAE,+EAA+E;IAC9F,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".plot-block-container {\r\n    width: 100%;\r\n    height: 400px;\r\n    border: var(--border);\r\n    border-radius: var(--border-radius);\r\n    margin: 5px 0px;\r\n    letter-spacing: normal;\r\n}\r\n\r\n.plot-grid-container {\r\n    border-radius: var(--border-radius);\r\n}\r\n\r\n.plot-grid-content-box {\r\n    padding: 5px;\r\n    height: calc(100% - 40px);\r\n    overflow: auto;\r\n    background: transparent;\r\n}\r\n\r\n/*TOOLTIP ZONE*/\r\n.tooltip-container {\r\n    margin: -10px; /*Negative margins give the user powers that some would consider... unnatural.*/\r\n    padding: 5px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.tooltip-container .echarts-legend-description {\r\n    max-width: 200px; \r\n    text-wrap: wrap;\r\n}\r\n\r\n.tooltip-container .tooltip-header {\r\n    padding: 0px 5px;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.tooltip-container .big-boy-marker {\r\n    display: block;\r\n    height: 12px;\r\n    width: 100%;\r\n    border-radius: 10px;\r\n}\r\n\r\n.tooltip-container .tooltip-body {\r\n    padding: 0px 5px;\r\n}\r\n\r\n.tooltip-container p {\r\n    margin: 0;\r\n    padding: 0 5px;\r\n}\r\n\r\n.tooltip-container p:first-of-type {\r\n    padding-left: 0;\r\n}\r\n\r\n.tooltip-container p:last-of-type {\r\n    padding-right: 0;\r\n}\r\n\r\n.tooltip-container .tooltip-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.tooltip-container .tooltip-row > * {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0 5px;\r\n    height: 100%;\r\n}\r\n\r\n.tooltip-container .tooltip-row .tooltip-row-identifier {\r\n    display: flex;\r\n    padding: 0;\r\n    margin-right: 5px;\r\n}\r\n\r\n.tooltip-container .tooltip-value {\r\n    font-weight: bold;\r\n}\r\n\r\n.tooltip-container .tooltip-single-value {\r\n    font-weight: bold;\r\n    font-size: larger;\r\n}\r\n\r\n.tooltip-container .tooltip-row:has(.tooltip-single-value) {\r\n    justify-content: center;\r\n}\r\n\r\n.tooltip-container .tooltip-row:has(:only-child) {\r\n    justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
